import Swiper, { A11y, Autoplay, EffectFade, Navigation, Pagination } from 'swiper'

const body  = document.querySelector('body');
const home  = body.classList.contains('home');

if (home) {

    // slider Actualités
    const postsSlideshow = document.querySelector('.posts .swiper-container') !== null;
                
    if (postsSlideshow) {
        let postsSlides = document.querySelectorAll('.posts .swiper-container .swiper-slide').length;

        Swiper.use([ A11y, Navigation, EffectFade, Autoplay ]);

        let postsConfig = {
            effect : 'fade', 
            grabCursor : 'false',
            speed: 700,
            loop: true,
            slidesPerView: 'auto',
            
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
            },

            breakpoints: {
                0: { // when window width is >= 0px 
                    autoplay: false
                },
        
                641: { // when window width is >= 641 
                    autoplay: {
                        delay: 6000,
                        disableOnInteraction: false,
                    }
                }
            },
        

            fadeEffect: {
                crossFade: true
            },

            keyboard: {
                enabled: true,
            },

            mousewheel: {
                forceToAxis: true,
                releaseOnEdges : true,
            },

            navigation: {
                nextEl: `.posts .swiper-button-next`,
                prevEl: `.posts .swiper-button-prev`,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            }
        }

        if(postsSlides > 1) {
            let swiperposts = new Swiper('.posts .swiper-container', postsConfig);

            let btnPause = document.querySelector('.swiper-button-pause');
            let btnPlay  = document.querySelector('.swiper-button-play');


            btnPause.addEventListener('click', function () {
                swiperposts.autoplay.stop();
                btnPause.style.display = "none";
                btnPlay.style.display = "flex";
            });
            btnPlay.addEventListener('click', function () {
                swiperposts.autoplay.start();
                btnPause.style.display = "flex";
                btnPlay.style.display = "none";
            });
        }
    }

}
